import React, { useState, useEffect } from 'react'
import { FormControlLabel, Switch, Grid, Box } from '@material-ui/core'
import Approval from '@mui/icons-material/Approval'
import { useTrans } from '../../../../services/i18n'
import { useAlertContext } from '../../../../contexts/AlertContext'
import SpacingContainerBase from '../../../../components/layouts/SpacingContainerBase'
import { Paper, SpacingContainer } from '../../../../components/common/Containers'
import Typography from '../../../../components/common/Typography'
import connect from '../connect'

const ToggleForceSubscription = ({ detail, toggleForceSubscription }) => {
  const { trans } = useTrans()
  const { successAlert, errorAlert } = useAlertContext()
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    if (detail) setChecked(detail.forceSubscription)
  }, [detail])

  const handleChange = async () => {
    try {
      const res = await toggleForceSubscription({ id: detail.id })
      const newValue = res.payload.forceSubscription
      setChecked(newValue)
      successAlert(trans('force_subscription_updated'))
    } catch {
      errorAlert(trans('force_subscription_update_failed'))
    }
  }

  return (
    <SpacingContainerBase py={0}>
      <Box mt={4}>
        <Paper component={SpacingContainer} py={3} px="5sm3">
          <Grid container justifyContent="space-between" alignItems="center" spacing={3}>
            <Grid item xs zeroMinWidth>
              <Typography
                style={{ paddingBottom: '1rem', alignItems: 'center', display: 'flex' }}
                variant="h4"
                weight="500"
                fontFamily="lexend"
              >
                <Approval style={{ marginRight: '0.5rem' }} />
                {trans('force-subscription')}
              </Typography>
            </Grid>
          </Grid>

          <Box
            style={{
              borderTop: `1px solid rgba(78, 89, 120, 0.12)`,
              padding: '2rem 0',
            }}
          >
            <Grid container alignItems="center" spacing={3}>
              <Grid item>
                <FormControlLabel
                  control={
                    <Switch
                      checked={checked}
                      onChange={handleChange}
                      color="primary"
                    />
                  }
                  label={trans('force-subscription')}
                />
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Box>
    </SpacingContainerBase>
  )
}

export default connect(ToggleForceSubscription)